import styles from "./TimelineDirectory.module.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddClipToTimeline, getFootageVideo, SetIsHandleKeyboard } from "../../store/actions/TimelineActions";
import { DeleteDir, DeleteFootage, GetDir } from "../../store/actions/DirectoryActions";
import { AppState } from "../../../root/RootReducer";
import { createStyles, makeStyles, Modal, Slider } from "@material-ui/core";
import PuiTypography from "../../../components/elements/PuiTypography";
import { stringifyVideoTimeWithColons } from "../../../common/video/util/videoTimeStrings";
import { GetFootageUrlFromId } from "../../../utils/TimelineUtils";
import FolderIcon from "@material-ui/icons/Folder";
import VideoFile from "../../../assets/icon/VideoFile";
import DirectoryPath from "../directory/DirectoryPath";
import { MoreVert } from "@material-ui/icons";
import TimelineTopModal from "../timelineTop/TimelineTopModal";
import CreateDirectoryModal from "../directory/CreateDirectoryModal";
import { useInitText } from "../../../components/function/useInitText";
import { useInitNumber } from "../../../components/function/useInitNumber";
import { useInitFlag } from "../../../components/function/useInitFlag";
import RenameObjectModal from "../../../common/components/modal/RenameObjectModal";

/**
|--------------------------------------------------
| タイムラインディレクトリコンポーネント
|--------------------------------------------------
*/

const useStyles = makeStyles(() =>
    createStyles({
        slider: {
            "& .MuiSlider-rail": {
                height: "70px",
                backgroundColor: "#000000",
                opacity: "0.3",
                borderRadius: "5px",
            },
            "& .MuiSlider-track": {
                height: "70px",
                backgroundColor: "#28233E",
            },
            "& .MuiSlider-thumb": {
                width: "30px",
                height: "70px",
                borderRadius: "5px",
                top: "18px",
                backgroundColor: "#9C9C9C",
            },
            "& span:nth-child(4)::after": {
                top: "28px",
                left: "12px",
                right: 0,
                bottom: 0,
                width: "8px",
                height: "8px",
                borderBottom: "2.5px solid #1c1c1c",
                borderLeft: "2.5px solid #1c1c1c",
                borderRadius: 0,
                transform: "rotate(45deg)",
            },
            "& span:nth-child(5)::after": {
                top: "28px",
                left: "8px",
                right: 0,
                bottom: 0,
                width: "8px",
                height: "8px",
                borderBottom: "2.5px solid #1c1c1c",
                borderLeft: "2.5px solid #1c1c1c",
                borderRadius: 0,
                transform: "rotate(-135deg)",
            },
        },
    })
);

// interface TimelineDirectoryProps {
//     isVideoPlayable: boolean;
// }

export default function TimelineDirectory() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const directoryRef = useRef<HTMLTableElement | null>(null);
    // const [isPlay, setIsPlay] = useState(false);
    const [isAddClipModalOpen, setIsAddClipModalOpen] = useState(false);
    const [selectedPathList, setSelectedPathList] = useState<any[]>([{ id: 0, name: "メディア" }]);
    const [footageId, setFootageId] = useState(0);
    const [footageUrl, setFootageUrl] = useState<string>("");
    const [fileName, setFileName] = useState("");
    const [minRangeValue, setMinRange] = useState<number>(0);
    const [maxRangeValue, setMaxRange] = useState<number>(0);
    const [videoDuration, setVideoDuration] = useState<number>(0);
    const [footageStatus, setFootageStatus] = useInitText();
    const editVideoRef = useRef<HTMLVideoElement>(null);

    const { directoryList, footageList, user, timeline } = useSelector((state: AppState) => ({
        directoryList: state.directory.directoryList,
        footageList: state.directory.footageList,
        user: state.user.user,
        timeline: state.timeline.timeline,
    }));

    //ディレクトリを選択した場合
    const handleClickDirectory = (id: number, name: string) => {
        // ディレクトリ一覧取得APIコール
        if (user) dispatch(GetDir(id, Number(user.id)));
        // 表示するディレクトリ
        setCurrentDirectory({ id, name });
        // rootからディレクトリが変わったかの判断
        const isDirectory = selectedHistoryPathList.some((path) => {
            return path.id === id;
        });
        //履歴用の配列
        let tempSelectHistoryPathList: any[] = [];
        if (selectedPathList.length === 1 && !isDirectory && selectedHistoryPathList.length > 1) {
            tempSelectHistoryPathList = [{ id: 0, name: "メディア" }];
        } else {
            tempSelectHistoryPathList = selectedHistoryPathList;
        }
        tempSelectHistoryPathList.push({
            id: id,
            name: name,
        });
        // 履歴用の配列に保存
        setSelectedhistoryPathList(tempSelectHistoryPathList);

        // 選択したフォルダーID・フォルダー名を配列に保存
        setSelectedPathList([
            ...selectedPathList,
            {
                id: id,
                name: name,
            },
        ]);
        if (!directoryRef || !directoryRef.current) return;
        directoryRef.current.scrollTop = 0;
    };

    // ビデオ編集モーダル閉じる
    const handleCloseAddClipModal = () => {
        setMinRange(0);
        setMaxRange(0);
        setVideoDuration(0);
        setIsAddClipModalOpen(false);
        dispatch(SetIsHandleKeyboard(true)); // 編集する際に、キーボードによるvideoのコントロールを無効にする
        // setIsPlay(false);
    };

    // フッテージをクリックで「addClipModal」モーダルを開く
    const handleClickFootage = (id: number, status: string) => {
        dispatch(SetIsHandleKeyboard(false)); // 編集する際に、キーボードによるvideoのコントロールを無効にする
        setIsAddClipModalOpen(true);
        setFootageStatus(status);
        if (id) {
            setFootageUrl(GetFootageUrlFromId(id));
            setFootageId(id);
            dispatch(getFootageVideo(id));
        }
    };

    // ドラッグ操作で、開始・終了時間を設定
    const handleRangeChange = (event: React.ChangeEvent<{}>, value: number | number[]) => {
        editVideoRef.current?.pause();
        // setIsPlay(false);
        if (typeof value === "object") {
            // クリップの最小値を設定
            if (minRangeValue !== value[0]) {
                // setMinRange(value[0]);
                setMinRange(Math.round(value[0] / 1000) * 1000);
                if (editVideoRef && editVideoRef.current) {
                    editVideoRef.current.currentTime = Math.round(value[0] / 1000);
                }
            }

            // クリップの最大値を設定
            if (maxRangeValue !== value[1]) {
                // setMaxRange(value[1]);
                setMaxRange(Math.floor(value[1] / 1000) * 1000);
                if (editVideoRef && editVideoRef.current) {
                    editVideoRef.current.currentTime = Math.round(value[1] / 1000);
                }
            }
        }
    };

    // クリップの追加
    const handleAddClip = () => {
        if (user && footageId && timeline && timeline.clipList && maxRangeValue !== 0) {
            const lastClip = timeline.clipList[timeline.clipList.length - 1];
            const seq = lastClip ? lastClip.seq + 1 : timeline.clipList.length; //追加したクリップのseqを最後にする（１番目は１です！）
            dispatch(
                AddClipToTimeline(
                    timeline.timeline.id,
                    footageId,
                    minRangeValue,
                    maxRangeValue,
                    seq,
                    Number(user.id)
                )
            );
            handleCloseAddClipModal();
        }
    };

    // 動画の読み込みが完了する時、動画の長さと再生時間を設定する。
    const handleVideoOnLoad = () => {
        const video = editVideoRef.current;
        if (video) {
            setVideoDuration(Math.floor(video.duration) * 1000);
            setMaxRange(Math.floor(video.duration) * 1000);
        }
    };

    // // Spaceキーによる動画の再生、一時停止
    // const handlePlayPause = (event: KeyboardEvent) => {
    //     if (event.keyCode === 32) {
    //         setIsPlay(!isPlay);
    //     }
    // };

    // // Spaceキーによる動画の再生、一時停止
    // useEffect(() => {
    //     document.addEventListener("keydown", handlePlayPause, false);

    //     if (isPlay) {
    //         editVideoRef.current?.play();
    //     } else {
    //         editVideoRef.current?.pause();
    //     }

    //     return () => {
    //         document.removeEventListener("keydown", handlePlayPause, false);
    //     };
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isAddClipModalOpen, isPlay]);

    // ファイル名を取得
    useEffect(() => {
        if (!footageList || footageList.length === 0) return;

        const currentClip = footageList.find((item) => item.id === footageId);
        setFileName(currentClip && currentClip.name ? currentClip.name : "");
        // eslint-disable-next-line
    }, [footageList, footageId]);

    // ディレクトリを取得
    useEffect(() => {
        if (user) {
            dispatch(GetDir(0, Number(user.id)));
        }
        // eslint-disable-next-line
    }, [user]);

    // 履歴用
    const [selectedHistoryPathList, setSelectedhistoryPathList] = useState<
        { id: number; name: string }[]
    >([{ id: 0, name: "メディア" }]);

    // 現在のディレクトリ
    const [currentDirectory, setCurrentDirectory] = useState<{ id: number; name: string }>({
        id: 0,
        name: "メディア",
    });

    // 編集modal表示用
    const [directoryIndex, setDerectoryIndex] = useState<number>(-1);
    const [footageIndex, setFootageIndex] = useState<number>(-1);

    // フォルダ三点リーダ押下時
    const ChangeDirectoryIndex = (index: number) => {
        setDerectoryIndex(index);
    };

    // 動画三点リーダ押下時
    const ChangeFootageIndex = (index: number) => {
        setFootageIndex(index);
    };

    // フォルダー名変更処理
    const [editFolderId, setEditFolderId] = useState(0);
    const [editFolderName, setEditFolderName] = useState("");
    const [isOpenFolderModal, setIsOpenFolderModal] = useState<boolean>(false);

    // 名前を変更ボタン押下時
    const handleEditFolder = (id: number, name: string) => {
        dispatch(SetIsHandleKeyboard(false));
        setEditFolderId(id);
        setEditFolderName(name);
        // フォルダー名変更するモーダルを呼び出す
        setIsOpenFolderModal(true);
        ChangeDirectoryIndex(-1);
    };

    const [deleteId, setDeleteId] = useState(-1);

    const [isOpenVerifyDeleteFolderModal, ShowVerifyDeleteFolderModal] = useState(false);

    // フォルダー削除モーダルを表示
    const OpenVerifyDeleteFolderModal = () => {
        ShowVerifyDeleteFolderModal(true);
        ChangeDirectoryIndex(-1);
    };
    // 削除ボタン押下時
    const handleDeleteFolder = (id: number, hasDir: boolean) => {
        OpenVerifyDeleteFolderModal();
        setDeleteId(id);
        ChangeDirectoryIndex(-1);
    };

    // ディレクトリ削除処理
    const handleDirectoryDelete = () => {
        if (user) {
            dispatch(DeleteDir(deleteId, true, Number(user.id)));
        }
        ShowVerifyDeleteFolderModal(false);
    };

    // フッテージ名変更処理
    const [editFootageId, setEditFootageId] = useInitNumber();
    const [editFootageName, setEditFootageName] = useInitText();
    // フォルダ名編集ポップアップ表示フラグ
    const [isOpenRenameFootageModal, setOpenRenameFootageModal] = useInitFlag();

    // フッテージ名変更
    const handleEditFootage = (id: number, name: string) => {
        dispatch(SetIsHandleKeyboard(false));
        setEditFootageId(id);
        setEditFootageName(name);
        // フッテージ名変更するモーダルを呼び出す
        setOpenRenameFootageModal(true);
        ChangeFootageIndex(-1);
    };

    const [isOpenVerifyDeleteModal, ShowVerifyDeleteModal] = useState(false);

    //フッテージ削除ボタン押下時
    const handleDeleteFootage = (id: number) => {
        ShowVerifyDeleteModal(true);
        setFootageIndex(-1);
        setDeleteId(id);
    };

    // footage削除処理
    const handleFootageDelete = () => {
        if (user) {
            dispatch(
                DeleteFootage(
                    deleteId,
                    Number(user.id),
                    selectedPathList[selectedPathList.length - 1].id
                )
            );
        }
        ShowVerifyDeleteModal(false);
    };

    useEffect(() => {
        // クリップ追加モーダルの後ろがスクロールしないように
        const html = document.querySelector("html");
        if (!html) return;
        
        if (isAddClipModalOpen) {
            html.style.overflow = "hidden";
        } else {
            html.style.overflow = "";
        }
    }, [isAddClipModalOpen]);

    return (
        <>
            <div className={styles.directoryArea}>
                <DirectoryPath
                    selectedHistoryPathList={selectedHistoryPathList}
                    setSelectedhistoryPathList={setSelectedhistoryPathList}
                    directoryList={directoryList}
                    selectedPathList={selectedPathList}
                    setSelectedPathList={setSelectedPathList}
                    setCurrentDirectory={setCurrentDirectory}
                    currentDirectory={currentDirectory}
                    directoryRef={directoryRef}
                />

                <div className={styles.mainDiv} ref={directoryRef}>
                    {directoryList &&
                        directoryList.length > 0 &&
                        directoryList.map((directory, index) => (
                            <div key={directory.id} className={styles.subDirectory}>
                                <FolderIcon className={styles.folderIconDiv} />
                                <div
                                    className={styles.subDirectoryName}
                                    onClick={() =>
                                        handleClickDirectory(directory.id, directory.name)
                                    }
                                >
                                    <PuiTypography>{directory.name}</PuiTypography>
                                </div>
                                <div
                                    onClick={() => ChangeDirectoryIndex(index)}
                                    className={styles.icon}
                                >
                                    <MoreVert />
                                </div>
                                {index === directoryIndex && (
                                    <>
                                        <div className={styles.directoryEdit}>
                                            <div
                                                onClick={() => {
                                                    handleEditFolder(directory.id, directory.name);
                                                }}
                                            >
                                                <PuiTypography>名前を変更</PuiTypography>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    handleDeleteFolder(directory.id, directory.hasDirectory);
                                                }}
                                            >
                                                <PuiTypography> 削除</PuiTypography>
                                            </div>
                                        </div>
                                        <div className={styles.bg} onClick={() => ChangeDirectoryIndex(-1)} />
                                    </>
                                )}
                            </div>
                        ))}

                    {footageList &&
                        footageList.length > 0 &&
                        footageList.map((footage, index) => (
                            <div className={styles.subFootage} key={footage.id}>
                                <VideoFile />
                                <div
                                    onClick={() => handleClickFootage(footage.id, footage.status)}
                                    style={{ width: "calc(100% - 100px)" }}
                                >
                                    <PuiTypography>{footage.name}</PuiTypography>
                                </div>
                                <div
                                    onClick={() => ChangeFootageIndex(index)}
                                    className={styles.icon}
                                >
                                    <MoreVert />
                                </div>
                                {index === footageIndex && (
                                    <>
                                        <div className={styles.footageEdit}>
                                            <div
                                                onClick={() =>
                                                    handleEditFootage(footage.id, footage.name)
                                                }
                                            >
                                                <PuiTypography>名前を変更</PuiTypography>
                                            </div>
                                            <div onClick={() => handleDeleteFootage(footage.id)}>
                                                <PuiTypography> 削除</PuiTypography>
                                            </div>
                                        </div>

                                        <div className={styles.bg} onClick={() => ChangeFootageIndex(-1)}/>
                                    </>
                                )}
                                
                            </div>
                        ))}
                </div>
            </div>

            {/* クリップを追加するモーダル */}
            <Modal
                className={styles.addClipModal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                aria-hidden={false}
                open={isAddClipModalOpen}
                onClose={handleCloseAddClipModal}
                closeAfterTransition
            >
                <div className={styles.videoArea}>
                    {footageUrl && (
                        <div className={styles.videoAreaBox}>
                            {fileName && <div className={styles.title}>{fileName}</div>}
                            <div className={styles.videoBox}>
                                {(footageStatus?.toLowerCase() === "uploading" ||
                                    footageStatus?.toLowerCase() === "error") && (
                                    <div className={styles.errorDiv}>
                                        {footageStatus?.toLowerCase() === "error"
                                            ? "エラーが発生しました。メディアを再度アップロードしてください。"
                                            : "この動画は処理中です。しばらくしてから再度ご確認ください。"}
                                    </div>
                                )}
                                <video
                                    muted
                                    ref={editVideoRef}
                                    controls
                                    autoPlay={false}
                                    key={footageUrl}
                                    controlsList="nodownload"
                                    disablePictureInPicture
                                    className={styles.video}
                                    preload="metadata"
                                    onLoadedMetadata={handleVideoOnLoad}
                                >
                                    <source
                                        src={`${
                                            footageUrl +
                                            "#t=" +
                                            minRangeValue / 1000 +
                                            "," +
                                            maxRangeValue / 1000
                                        }`}
                                        type="video/mp4"
                                    />
                                </video>
                            </div>
                            
                            <div className={styles.durationMillis}>
                                <div>{stringifyVideoTimeWithColons(minRangeValue)}</div>
                                <div>{stringifyVideoTimeWithColons(maxRangeValue)}</div>
                            </div>
                            <Slider
                                max={videoDuration}
                                value={[minRangeValue, maxRangeValue]}
                                onChange={handleRangeChange}
                                style={{
                                    width: "100%",
                                    color: "white",
                                    fontWeight: "bold",
                                }}
                                className={classes.slider}
                            />
                            <div onClick={handleCloseAddClipModal} className={styles.cancelButton}>
                                キャンセル
                            </div>
                            <div
                                className={`${styles.addClipButton} ${
                                    maxRangeValue === 0 ? styles.isBtnDisabled : ""
                                }`}
                                onClick={handleAddClip}
                            >
                                完了
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
            {/* フォルダー削除確認モーダル表示 */}
            <TimelineTopModal
                message="フォルダーを削除しますか？"
                leftButtonText="キャンセル"
                rightButtonText="削除"
                leftButtonClick={() => ShowVerifyDeleteFolderModal(false)}
                rightButtonClick={handleDirectoryDelete}
                open={isOpenVerifyDeleteFolderModal}
                onClose={() => ShowVerifyDeleteFolderModal(false)}
            />
            {/* フッテージ削除確認モーダル表示 */}
            <TimelineTopModal
                message="フッテージを削除しますか？"
                leftButtonText="キャンセル"
                rightButtonText="削除"
                leftButtonClick={() => ShowVerifyDeleteModal(false)}
                rightButtonClick={handleFootageDelete}
                open={isOpenVerifyDeleteModal}
                onClose={() => ShowVerifyDeleteModal(false)}
            />
            {/* フォルダー作成モーダルを呼び出す */}
            <CreateDirectoryModal
                openCreateFolderModal={isOpenFolderModal}
                setOpenCreateFolderModal={setIsOpenFolderModal}
                createdFolderId={selectedPathList[selectedPathList.length - 1].id}
                editFolderId={editFolderId}
                editFolderName={editFolderName}
                setEditFolderName={setEditFolderName}
            />
            {/* フッテージ名変更モーダルを呼び出す */}
            <RenameObjectModal
                isOpenModal={isOpenRenameFootageModal}
                setOpenModal={setOpenRenameFootageModal}
                id={editFootageId}
                editName={editFootageName}
                setEditName={setEditFootageName}
                type={"フッテージ"}
            />
        </>
    );
}
